import { FC, useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import ClearIcon from '@tuhi/components/assets/icons/buttons/clear.svg'
import { BaseButton } from '../../components'
import { Tag } from './tag'

const WidthContainer = styled.span`
    position: absolute;
    opacity: 0;
    padding-right: 8px;
`

const StyledInput = styled.input<{
    $clickable?: boolean
    $width?: string
}>`
    width: ${(p) => p.$width};
    cursor: ${(p) => (p.$clickable ? 'pointer' : 'auto')};
    position: relative;
    border: 0;
    outline: none;
    padding: 0;
`

interface Props {
    text: string
    edit?: boolean
    onSave?: (text: string) => void
    onDelete: () => void
}

export const EditTag: FC<Props> = ({
    text,
    edit = false,
    onSave,
    onDelete,
}) => {
    const [isEdit, setIsEdit] = useState(edit)
    const [value, setValue] = useState(text)
    const [inputWidth, setInputWidth] = useState(0)

    const span = useRef<HTMLSpanElement>(null)

    const handleKeyDown = (key: string) => {
        if (key === 'Enter') {
            onSave?.(value)
            setIsEdit(!isEdit)
        }
    }

    useEffect(() => {
        setValue(text)
    }, [text])

    useEffect(() => {
        if (isEdit && span.current) {
            setInputWidth(span.current.offsetWidth + 2)
        }
    }, [value, isEdit])

    const input = useMemo(() => {
        return (
            <>
                <WidthContainer ref={span}>{value}</WidthContainer>
                <StyledInput
                    $width={`${inputWidth.toString()}px`}
                    value={value}
                    type="text"
                    autoFocus
                    onBlur={() => {
                        onSave?.(value)
                        setIsEdit(false)
                    }}
                    onChange={(event) => {
                        setValue(event.target.value)
                    }}
                    onKeyDown={(event) => {
                        handleKeyDown(event.key)
                    }}
                />
            </>
        )
    }, [value, inputWidth])

    return (
        <Tag
            onClick={() => {
                if (onSave && !isEdit) {
                    setIsEdit(!isEdit)
                }
            }}
        >
            {isEdit ? input : value}

            <BaseButton
                onClick={(e) => {
                    e.stopPropagation()
                    onDelete()
                }}
            >
                <ClearIcon />
            </BaseButton>
        </Tag>
    )
}
